import {Model, ModelMixin} from '../common/model.class';
import {Malpractice} from './malpractice.model';
import {LicensesAndAffiliations} from './licenses-and-affiliations.model';
import {DisciplinaryActions} from './disciplinary-actions.model';
import {HealthStatus} from './health-status.model';

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class ProfessionalLiability extends ModelMixin() implements Model<ProfessionalLiability> {

    TYPE = ProfessionalLiability;

    malpractice: Malpractice = new Malpractice();
    licensesAndAffiliations: LicensesAndAffiliations = new LicensesAndAffiliations();
    disciplinaryActions: DisciplinaryActions = new DisciplinaryActions();
    healthStatus: HealthStatus = new HealthStatus();

    constructor(jsonData: any = {}) {
        super();
        if (jsonData.malpractice) jsonData.malpractice = new Malpractice(jsonData.malpractice);
        if (jsonData.licensesAndAffiliations) jsonData.licensesAndAffiliations = new LicensesAndAffiliations(jsonData.licensesAndAffiliations);
        if (jsonData.disciplinaryActions) jsonData.disciplinaryActions = new DisciplinaryActions(jsonData.disciplinaryActions);
        if (jsonData.healthStatus) jsonData.healthStatus = new HealthStatus(jsonData.healthStatus);
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/liability/professional-liability.model.ts